import { render } from "./AddPackage.vue?vue&type=template&id=45cbc53c&class=z-index-3"
import script from "./AddPackage.vue?vue&type=script&lang=js"
export * from "./AddPackage.vue?vue&type=script&lang=js"

import "./AddPackage.vue?vue&type=style&index=0&id=45cbc53c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__